import React from 'react';
import { createGridTabsCss } from '../utils';
import './GridTabItem.scss';
const GridTabItem = ({ tab, disabled, active, onChange, className, overrideCss, }) => {
    const { gridTabItemCss, gridTabItemTextCss } = createGridTabsCss({
        customClassName: className,
        overrideCss,
        active,
        disabled,
    });
    const handleClick = () => {
        if (!disabled) {
            onChange(tab);
        }
    };
    return (React.createElement("button", { type: "button", className: gridTabItemCss, onClick: handleClick },
        React.createElement("span", { className: gridTabItemTextCss }, tab)));
};
export default GridTabItem;
//# sourceMappingURL=GridTabItem.js.map